/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { address } from './address';
import { common } from './common';
import { myAccount } from './my-account';
import { payment } from './payment';
import { pdf } from './pdf';
import { product } from './product';
import { pwa } from './pwa';
import { user } from './user';
import { video } from './video';

export const en = {
  address,
  common,
  myAccount,
  payment,
  product,
  pwa,
  user,
  video,
  pdf,
};
